import type { CalendarGridItem } from '../../hooks/useCalendarData';
import { formatGregorian, jalaliToGregorian, parseJalaliDateKey } from '../../utils/jalali';

export function gregorianDateParam(item: CalendarGridItem): string {
  const g = jalaliToGregorian(item.year, item.month, Number(item.day));
  return formatGregorian(new Date(g.year, g.month - 1, g.day));
}

/** Gregorian YYYY-MM-DD from Jalali date key (e.g. 1404/4/19). */
export function gregorianDateFromJalaliKey(dateKey: string): string | null {
  const parsed = parseJalaliDateKey(dateKey);
  if (!parsed) return null;
  const g = jalaliToGregorian(parsed.year, parsed.month, parsed.day);
  return formatGregorian(new Date(g.year, g.month - 1, g.day));
}

/** True when an API/storage date points at today in the browser's local timezone. */
export function isGregorianDateToday(dateParam: string, now = new Date()): boolean {
  return dateParam === formatGregorian(now);
}
